let IntentosPost3 = 0;
const PostAttachtmen = (url, files, content, resp) => {
    let data = new FormData();

    (files.length === 0) ? data.append("Adjunto", false) : data.append("Adjunto", true);

    files.map(file => {
        data.append("Archivos[]", file.files[0]);
    })

    data.append('Contenido', JSON.stringify(content));

    fetch(url, {
        method: 'POST', 
        body: data,
    })
    .then(response => {
        response.text().then(respuesta);
        function respuesta(data) {
            resp (data);
        }
    },error => {
        IntentosPost3++;
        (IntentosPost3 > 5) ? IntentosPost3 = 0 : PostAttachtmen(url, files, content, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })
}

export default PostAttachtmen;


// WEBPACK FOOTER //
// ./src/shared/PostAttachtmen.jsx